<template>
  <div
    class="tab-pane fade"
    id="user"
    role="tabpanel"
    aria-labelledby="legalitas-tab"
  >
    <div class="card-group">
      <div class="card">
        <div class="card-header">
          <h5 class="card-title mt-4">Buat User</h5>
        </div>
        <!-- <div class="card-body">
                    <h5 class="card-title">NPWP : *Max 500kb,(jpg or png)</h5>
                    <div class="text-center py-5">
                        <img :src="user.legality.npwp.image" class="img-responsive" onerror="imgError(this)"
                            width="40%" />
                    </div>
                </div> -->
        <div class="card-body">
          <form @submit.prevent="submitNewUser">
            <div class="form-group row">
              <label for="staticEmail" class="col-sm-2 col-form-label"
                >Nama Lengkap</label
              >
              <div class="col-sm-10">
                <input type="text" class="form-control" required id="namePic" />
              </div>
            </div>
            <div class="form-group row">
              <label for="staticEmail" class="col-sm-2 col-form-label"
                >Email</label
              >
              <div class="col-sm-10">
                <input
                  type="email"
                  class="form-control"
                  required
                  id="emailPic"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="staticEmail" class="col-sm-2 col-form-label"
                >Password</label
              >
              <div class="col-sm-10">
                <input
                  type="password"
                  class="form-control"
                  required
                  id="passwordUser"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="inputPassword" class="col-sm-2 col-form-label"
                >Phone</label
              >
              <div class="col-sm-10">
                <input
                  type="number"
                  class="form-control"
                  required
                  id="phonePic"
                />
              </div>
            </div>

            <div class="form-group row">
              <label for="inputPassword" class="col-sm-2 col-form-label"
                >Jabatan</label
              >
              <div class="col-sm-10">
                <select name="" required class="form-control" id="jabatanPic">
                  <option value="Admin Toko">Admin Toko</option>
                  <option value="Finance">Finance</option>
                  <option value="Manager">Manager</option>
                  <option value="Direktur">Direktur</option>
                </select>
              </div>
            </div>

            <button class="btn btn-primary">Tambah User</button>
          </form>
          <h5 class="card-title mt-4">List User</h5>
          <table
            class="table table-condensed text-center table-hover"
            width="100%"
          >
            <thead>
              <tr
                class="table-condensed text-uppercase text-muted text-sm-center"
              >
                <th>No</th>
                <th>Nama</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Jabatan</th>
                <th>Peran</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="listUser.length === 0">
                <td class="table-secondary" colspan="7">Tidak ada data</td>
              </tr>
              <tr v-for="(lu, index) in listUser" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ lu.nama }}</td>
                <td>{{ lu.email }}</td>
                <td>{{ lu.phone }}</td>
                <td>{{ lu.jabatan }}</td>
                <td>{{ lu.peran }}</td>
                <td>
                  <!-- <button
                    data-toggle="modal"
                    data-target="#exampleModal"
                    type="button"
                    class="btn btn-outline-default bg-transparent btn-sm"
                    style="width: 20px; border: 0px"
                    @click="waitingProd"
                  >
                    <i class="fas fa-pencil-alt"></i>
                  </button> -->
                  <button
                    type="button"
                    class="btn btn-outline-default bg-transparent btn-sm"
                    style="width: 20px; border: 0px"
                    @click="waitingProd"
                  >
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                  <a
                    href="#"
                    class="btn btn-outline-default bg-transparent btn-sm"
                    style="width: 20px; border: 0px"
                    @click="waitingProd"
                  >
                    <i class="fas fa-trash-alt"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- <div class="card">
                <div class="card-body">
                    <h5 class="card-title">SIUP/NIB: *Max 500kb(jpg or png)</h5>
                    <div class="text-center">
                        <img :src="user.legality.siup.image" class="img-responsive" onerror="imgError(this)"
                            width="30%" />
                    </div>
                </div>

                <form>
                    <div class="form-group">
                        <label for="header"></label>
                        <input type="file" class="form-control-file ml-3" id="header" />
                    </div>
                    <div class="text-center">
                        <button type="submit" class="btn btn-info my-3">
                            Update
                        </button>
                    </div>
                </form>
            </div> -->
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
import { mapGetters } from "vuex";
export default {
  props: {
    getUser: Function,
    submitNewUser: Function,
    listUser: Array,
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },

  methods: {
    waitingProd(){
      this.$toast.info('Masih dalam pengembangan')
    }
  },
};
</script>